import { DocketwiseActions } from './partials/docketwise'
import { ECOMemberPassIntegrationActions } from './partials/eco-member-pass'
import { ECOPortalIntegrationActions } from './partials/eco-portal'
import { ECOPortalIntegrationCaseStatsActions } from './partials/eco-portal-case-stats'
import { KioskIntegrationActions } from './partials/kiosk'
import { OWRIntegrationActions } from './partials/owr'
import { SignupIntegrationActions } from './partials/signup'
import { TmetricActions } from './partials/tmetric'

export const IntegrationActions = {
  ...DocketwiseActions,
  ...ECOMemberPassIntegrationActions,
  ...ECOPortalIntegrationActions,
  ...ECOPortalIntegrationCaseStatsActions,
  ...KioskIntegrationActions,
  ...OWRIntegrationActions,
  ...SignupIntegrationActions,
  ...TmetricActions,
}
